//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, onMounted, ref, toRefs, computed } from "@vue/composition-api";
import CommissionDeductions from "./commission-deductions.vue";
import * as LenderSubmitActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import * as LenderSubmitGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import { useApplicationStoreActions, useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import CommissionDeductionsLoader from "./loaders/commission-deductions-loader.vue";
export default defineComponent({
  name: "CommissionDeductionsContainer",
  components: {
    CommissionDeductions,
    CommissionDeductionsLoader
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    currentCommissionsMortgageType: {
      type: String,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    let loading = ref(false);
    const {
      GET_COMMISSION_DEDUCTION
    } = useApplicationStoreActions([LenderSubmitActions.GET_COMMISSION_DEDUCTION]);
    const {
      clientUsername,
      applicationId,
      currentCommissionsMortgageType
    } = toRefs(props);
    const getCommissionDeductions = async mortgageType => {
      loading.value = true;
      await GET_COMMISSION_DEDUCTION({
        clientUsername: clientUsername.value,
        applicationId: applicationId.value,
        mortgageType: mortgageType
      });
      loading.value = false;
    };
    onMounted(() => {
      getCommissionDeductions(currentCommissionsMortgageType.value);
    });
    const updateDeductions = value => {
      getCommissionDeductions(value);
    };
    const {
      GET_COMMISSION_DEDUCTIONS_TOTAL
    } = useApplicationStoreGetters([LenderSubmitGetters.GET_COMMISSION_DEDUCTIONS_TOTAL]);
    const totalCommissionDeduction = computed(() => {
      return GET_COMMISSION_DEDUCTIONS_TOTAL.value(applicationId.value);
    });
    return {
      loading,
      updateDeductions,
      totalCommissionDeduction
    };
  }
});